import { List } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { IndexListItem } from 'components/styles_components/list';
import ListItem from 'components/inspection_subject/index/list_item';
import ListHeader from 'components/inspection_subject/index/list_header';
import LoaderContainer from 'components/layout/loader_container';
import InfoContainer from 'components/info_container';

const Index = ({ inspectionSubjects, sortBy, onSortChange, loading }) => {
  return (
    <List>
      <ListHeader sortBy={sortBy} onSortChange={onSortChange} />
      <LoaderContainer loading={loading} wrap={false} keepRenderedContent={true}>
        {inspectionSubjects.inspectionSubjects.map((inspectionSubject) => (
          <ListItem key={inspectionSubject.id} inspectionSubject={inspectionSubject} />
        ))}
      </LoaderContainer>
      {!loading && inspectionSubjects.inspectionSubjects.length === 0 && (
        <IndexListItem>
          <InfoContainer>
            <FormattedMessage id="empty.inspection_subjects.title.short" />
          </InfoContainer>
        </IndexListItem>
      )}
    </List>
  );
};

export default Index;
